"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Transform", {
  enumerable: true,
  get: function get() {
    return _classTransformer.Transform;
  }
});
Object.defineProperty(exports, "Type", {
  enumerable: true,
  get: function get() {
    return _classTransformer.Type;
  }
});
exports.classToClass = void 0;
Object.defineProperty(exports, "classToPlain", {
  enumerable: true,
  get: function get() {
    return _classTransformer.instanceToPlain;
  }
});
exports.plainToClass = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _classTransformer = require("class-transformer");

var _TypeClassDecorator = require("./TypeClassDecorator");

/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 31/10/2021
 */
var transformWrapperFactory = function transformWrapperFactory(baseClass, discriminator) {
  var _dec, _class, _descriptor;

  return _dec = (0, _classTransformer.Type)(function () {
    return baseClass;
  }, discriminator), (_class = /*#__PURE__*/(0, _createClass2["default"])(function _class() {
    (0, _classCallCheck2["default"])(this, _class);
    (0, _initializerDefineProperty2["default"])(this, "data", _descriptor, this);
  }), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
};

var isAnnotatedClass = function isAnnotatedClass(obj) {
  if (!obj) {
    return true;
  }

  var metadata = Reflect.getMetadata(_TypeClassDecorator.typeClassKey, obj.constructor);
  return metadata && metadata.options && metadata.options.discriminator;
};

var plainToClass = function plainToClass(clazz, obj) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var res;
  var metadata = Reflect.getMetadata(_TypeClassDecorator.typeClassKey, clazz); // console.log("plainToClass: metadata = ", metadata, ", clazz = ", clazz)

  if (metadata && metadata.options && metadata.options.discriminator) {
    var objWrapper = {
      data: obj
    }; // if(!clazz.clazzTypeWrapper){

    clazz.clazzTypeWrapper = transformWrapperFactory(clazz, metadata.options); // }

    var resWrapper = (0, _classTransformer.plainToInstance)(clazz.clazzTypeWrapper, objWrapper, metadata.options); // console.log("plainToClass: resWrapper = ", resWrapper)

    res = resWrapper.data;
  } else if (options.discriminator) {
    var _objWrapper = {
      data: obj
    };
    var clazzWrapper = transformWrapperFactory(clazz, options);

    var _resWrapper = (0, _classTransformer.plainToInstance)(clazzWrapper, _objWrapper, options);

    res = _resWrapper.data;
  } else {
    res = (0, _classTransformer.plainToInstance)(clazz, obj, options);
  }

  return res;
};

exports.plainToClass = plainToClass;

var classToClassCustom = function classToClassCustom(obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!obj) {
    return obj;
  }

  var plain = (0, _classTransformer.instanceToPlain)(obj);
  return plainToClass(obj.constructor, plain, options);
};

var classToClass = function classToClass(obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isAnnotatedClass(obj)) {
    return classToClassCustom(obj, options);
  }

  return (0, _classTransformer.instanceToInstance)(obj, options);
};

exports.classToClass = classToClass;